import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-information',
  imports: [],
  templateUrl: './modal-information.component.html',
  styleUrl: 'modal-information.component.scss'
})
export class ModalInformationComponent {
  @Input() message = '';
  @Input() title = '';
  @Input() type: 'error' | 'success' | 'info' = 'info';

  private activeModal = inject(NgbActiveModal);

  close() {
    this.activeModal.close();
  }
}
